import Externo from './Externo'

export default Externo;